import { AxiosPromise }         from 'axios';
import { Layout }               from '@/components/chart/chart.types';
import { chartUuidMock }        from '@/helpers/variables';
import { client }               from '@/service/client';
import { ChartPosition }        from '@/components/chart/helpers/chart-variables';
import { ObjectWithStringKeys } from '@/types';
import { BuilderConfiguration } from '@/views/x-axis-report/report-edit/types/types';

export function getChartLayoutService(): Promise<Layout[]> {
  return new Promise((resolve) => {
    resolve([
      { chartUuid: chartUuidMock, layoutCode: ChartPosition.TOP_LEFT },
    ]);
  });
}

export const getFunctions = (): AxiosPromise => (
  client.get('/x-axis-reports/functions')
);

export const getAllElements = (): AxiosPromise => (
  client.get('/x-axis-reports/elements')
);

export const calculateReport = (configuration: ObjectWithStringKeys<BuilderConfiguration[]>): AxiosPromise => (
  client.put('/x-axis-reports/calculate', {
    ...configuration,
  })
);

export const postXAxisReport = (configuration: ObjectWithStringKeys<BuilderConfiguration[] | string>): AxiosPromise => (
  client.post('/x-axis-reports', {
    ...configuration,
  })
);

export const putXAxisReport = (configuration: ObjectWithStringKeys<BuilderConfiguration[] | string>, uuid: string): AxiosPromise => (
  client.put(`/x-axis-reports/${uuid}`, {
    ...configuration,
  }));

export const getXAxisConfiguration = (configurationUuid: string): AxiosPromise => client.get(`/x-axis-reports/${configurationUuid}`);
